// determines whether execution can continue during a status-ful Async action
export default function waiting (state = false, action) {
  if (action.type.endsWith('_REQUEST')) {
    return true
  } else if (action.type.endsWith('_FAILURE') ||
           action.type.endsWith('_SUCCESS')) {
    return false
  }
  return state
}
